import { Pane } from '@leverege/ui-elements'
import { TitleBar } from '@leverege/ui-plugin'
import { ParentSize } from '@visx/responsive'
import React, { useMemo } from 'react'
import { isDuringBusinessHours } from '../../../../util'
import UsageBarChart from './UsageBarChart'
import UsageStackedBarGroupChart from './UsageStackedBarGroupChart'

export default function HourlyUsage( { title, type, style, ...rest } ) {
  const data = useMemo( () => {
    return rest.data.filter( ( item ) => {
      return item.type === type && isDuringBusinessHours( item, rest.businessDays )
    } )
  }, [ rest.data, rest.businessDays, type ] )

  return (
    <Pane
      style={style}
      variant="graphCard">
      <TitleBar
        variant="analyticsCardTitle|cardTitle"
        title={title} />
      <ParentSize>
        {( { width, height } ) => {
          if ( rest.businessDays.length === 1 ) {
            return (
              <UsageBarChart
                {...rest}
                data={data}
                width={width}
                height={height} />
            )
          }

          // TODO: GROUPED BAR CHART
          return (
            <UsageStackedBarGroupChart
              {...rest}
              data={data}
              width={width}
              height={height} />
          )
        }}
      </ParentSize>
    </Pane>
  )
}
